import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom';

function CrmMyTickets(props) {

    const navigate = useNavigate();
    
    const handleClick = (event) => {
        navigate("/crm/my-tickets");
    };

    return (
        <Tooltip title="My Tickets" placement="top">
            <IconButton
                className="w-40 h-40"
                aria-controls="font-size-menu"
                aria-haspopup="true"
                size="large"
                onClick={handleClick}
            >
                <Icon>mail_outline</Icon>
            </IconButton>
        </Tooltip>
    );
}

export default CrmMyTickets;
